import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

const Heading = (props) => {
    const { level, children, ...headingProps } = props;
    switch (level) {
    case '1': return <h1 { ...headingProps }>{children}</h1>
    case '2': return <h2 { ...headingProps }>{children}</h2>
    case '3': return <h3 { ...headingProps }>{children}</h3>
    case '4': return <h4 { ...headingProps }>{children}</h4>
    case '5': return <h5 { ...headingProps }>{children}</h5>
    case '6': return <h6 { ...headingProps }>{children}</h6>
    default: return <h5 { ...headingProps }>{children}</h5>
    }
}

Heading.defaultProps = {
    'level': '5'
};

Heading.propTypes = {
    'children': PropTypes.any.isRequired,
    'level': PropTypes.string
};

export default Heading;



// WEBPACK FOOTER //
// ./src/components/gdc-components-atoms-heading/index.jsx